export default __webpack_public_path__ + "static/media/crude-graph-on1.b76f4561.svg";